import { useSearchParams } from 'react-router-dom';
import { USER_TYPES } from 'constants';
import CompanySignUp from './CompanySignUp';
import SeekerSignUp from './SeekerSignUp';

const Signup: React.FC = () => {
	const [searchParams] = useSearchParams();
	const userType = searchParams.get('userType');
	return userType === USER_TYPES.COMPANY ? <CompanySignUp /> : <SeekerSignUp />;
};

export default Signup;
